import { createContext, useContext, useRef } from 'react';
import { proxy, useSnapshot } from 'valtio';
import { jsx as _jsx } from "react/jsx-runtime";
var TaskListCtx = /*#__PURE__*/createContext({});
export var TaskListProvider = function TaskListProvider(_ref) {
  var children = _ref.children;
  var state = useRef(proxy({
    todoType: 1,
    todoTimeType: 0,
    flowOrderName: undefined,
    classifyCode: undefined,
    startTime: undefined,
    endTime: undefined
  })).current;
  return /*#__PURE__*/_jsx(TaskListCtx.Provider, {
    value: state,
    children: children
  });
};
export var useTaskList = function useTaskList() {
  var state = useContext(TaskListCtx);
  var snap = useSnapshot(state);
  return [snap, state];
};